import { client } from "./shopifyClient";


const CREATE_CART = `
  mutation CartCreate($input: CartInput!) {
    cartCreate(input: $input) {
      cart {
        id
        checkoutUrl
      }
      userErrors {
        field
        message
      }
    }
  }
`;

export const createCart = async (variantIds: string[], quantities: number[]) => {
  if (variantIds.length !== quantities.length) {
    console.error("variantIds y quantities deben tener la misma longitud");
    return null;
  }

  const lines = variantIds.map((id, index) => ({
    merchandiseId: id,
    quantity: quantities[index],
  }));

 const res = await client.request(CREATE_CART, {
  variables: {
    input: {
      lines,
    },
  },
});

  const cart = res?.data.cartCreate?.cart;
  const errors = res?.data.cartCreate?.userErrors;

  if (errors?.length) {
    console.error('Errores al crear carrito:', errors);
    return null;
  }

  return cart;
};
